import React from "react";

import { Box, Heading, Stack, Text } from "@seneca/senekit";

import ProgressBar from "features/classroom/common/ProgressBar";

type Props = {
  children: React.ReactElement<any>;
  header: string;
  pageNumber: number;
  totalNumberOfPages: number;
};

export default function SignUpWithProgressBarWrapper({
  children,
  header,
  pageNumber,
  totalNumberOfPages
}: Props) {
  return (
    <Box padding={["none", "xlarge"]}>
      <Stack align="center" space="xlarge">
        <Box
          display="flex"
          flexDirection={["column", "row"]}
          justifyContent="space-between"
          alignItems="baseline"
          width="100%"
        >
          <Heading level="3">{header}</Heading>
          <Text size="small">
            {pageNumber} of {totalNumberOfPages} steps
          </Text>
        </Box>
        <ProgressBar
          progress={(pageNumber / totalNumberOfPages) * 100}
          size="MEDIUM"
        />
        {children}
      </Stack>
    </Box>
  );
}
